(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qb-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const scriptEl = document.currentScript;
    const card = scriptEl ? scriptEl.closest('product-card') : null;
    if (!card) return;

    // Add click event listener to the entire card for navigation
    card.addEventListener('click', (e) => {
      // Don't navigate if clicking on interactive elements
      if (
        e.target.closest('button') ||
        e.target.closest('a') ||
        e.target.closest('select') ||
        e.target.closest('input') ||
        e.target.closest('label')
      ) {
        return;
      }

      const link = card.querySelector('.product-card__link');
      if (link && link.href) {
        window.location.href = link.href;
      }
    });

    const unitsEl = card.querySelector('[data-units]');
    const variantIdInput = card.querySelector('input[ref="variantId"]');
    const addButton = card.querySelector('.qb-card__add-to-cart');
    const productLink = card.querySelector('[ref="productCardLink"]');
    const select = card.querySelector('.qb-variant-select');
    const buyNowLink = card.querySelector('.qb-card__quick-view');

    const productForm = card.querySelector('product-form-component');
    const productId = (productForm && productForm.dataset.productId) || card.dataset.productId || '';
    const productUrl = (productForm && productForm.dataset.productUrl) || (productLink && productLink.href) || '';

    async function buildHtmlForVariant(vid) {
      if (!productUrl || !vid) return null;
      try {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('variant', String(vid));
        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc;
      } catch (e) {
        console.warn('qb-product-card: failed to fetch product HTML for variant', e);
        return null;
      }
    }

    async function updateFromSelect() {
      if (!select) return;
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      const vid = opt.getAttribute('data-variant-id');
      const available = opt.getAttribute('data-available') === 'true';
      const qty = parseInt(opt.getAttribute('data-qty') || '0', 10);
      if (variantIdInput && vid) variantIdInput.value = vid;
      if (addButton) addButton.disabled = !available || card.dataset.comingSoon === 'true';
      if (unitsEl) unitsEl.textContent = available ? `${qty} units` : 'Unavailable';
      if (productLink && vid) {
        try {
          const url = new URL(productLink.href, window.location.origin);
          url.searchParams.set('variant', vid);
          productLink.href = url.toString();
        } catch (e) {}
      }

      // Notify theme listeners about variant change
      const variantResource = {
        id: Number(vid),
        available,
        inventory_management: 'shopify',
        inventory_quantity: qty,
      };
      const htmlDoc = await buildHtmlForVariant(vid);
      const detail = {
        resource: variantResource,
        sourceId: productId || 'qb-product-card',
        data: {
          html: htmlDoc,
          productId: productId || '',
        },
      };
      card.dispatchEvent(new CustomEvent('variant:update', { detail, bubbles: true }));
    }

    if (select) {
      // Initialize state to ensure hidden input/link reflect current selection
      // Pick a random available variant (fallback to any variant)
      const options = Array.from(select.options);
      console.log('Select Options:', options);
      const availableOptions = options.filter((o) => o.getAttribute('data-available') === 'true');
      const pool = availableOptions.length > 0 ? availableOptions : options;
      const randomOpt = pool[Math.floor(Math.random() * pool.length)];
      if (randomOpt) {
        select.value = randomOpt.value;
      }
      updateFromSelect();
      select.addEventListener('change', updateFromSelect);
    }

    card.addEventListener(
      'variant:update',
      (e) => {
        try {
          const variant = e.detail?.resource;
          if (unitsEl) {
            if (variant && variant.inventory_management === 'shopify') {
              const qty = Number(variant.inventory_quantity || 0);
              unitsEl.textContent = `${qty} units`;
            } else {
              unitsEl.textContent = '';
            }
          }

          // Update hidden input with variant id
          if (variantIdInput && variant?.id) {
            variantIdInput.value = String(variant.id);
            if (variant.available === false) {
              variantIdInput.setAttribute('disabled', 'disabled');
            } else {
              variantIdInput.removeAttribute('disabled');
            }
          }

          // Toggle Add to Cart availability
          if (addButton instanceof HTMLButtonElement && variant) {
            addButton.disabled = !variant.available || card.dataset.comingSoon === 'true';
          }

          // Update product card link to keep selected variant in URL
          if (productLink instanceof HTMLAnchorElement && variant?.id) {
            const url = new URL(productLink.href, window.location.origin);
            url.searchParams.set('variant', String(variant.id));
            productLink.href = url.toString();
          }

          // Update Buy Now link
          if (buyNowLink instanceof HTMLAnchorElement && variant?.id) {
            buyNowLink.href = `/cart/${variant.id}:1`;
            if (variant.available) {
              buyNowLink.style.pointerEvents = 'auto';
              buyNowLink.style.opacity = '1';
            } else {
              buyNowLink.style.pointerEvents = 'none';
              buyNowLink.style.opacity = '0.5';
            }
          }
        } catch (err) {
          console.error('qb-product-card units update error', err);
        }
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
